<template>
  <div v-wechat-title="titleTop">
    <audio id="audioBgm" autoplay loop preload="auto">
      <source src="https://res.diveboss.net/activity/ilab202205/bgm.mp3" type="audio/mpeg">
    </audio>
    <div v-show="state==='welcome'" class="AllBack">
      <div class="topSwipe">
        <swiper ref="imgSwiper" :options="swiperOption" @slideChange="onImgChange()">
          <!-- 幻灯内容 -->
          <swiper-slide v-for="item in picList" :key="item.id" class="topImg"><img :src="item.src"></swiper-slide>
          <div slot="pagination" class="swiper-pagination" />
        </swiper>
      </div>
      <div class="aboutStr">
        &lt; 左右滑动选择我的环保海报 &gt;
      </div>
      <div class="inputRect">
        <van-field
          v-model="nickName"
          placeholder="输入姓名或昵称"
          class="inputLine"
          maxlength="10"
        />
      </div>
      <div :class="buttonLoading?'buttonRect buttonRectSelect':'buttonRect'" @click="onBuild">
        <span>生成我的专属海报</span>
      </div>
    </div>
    <div v-show="state==='paper'" class="papaerRect">
      <div class="papaer">
        <div class="shareAbout">长按保存图片 分享一下</div>
        <img :src="papaerImgSrc">
      </div>
    </div>
    <wxShare v-model="showShare" share-title="点击这里分享" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Dialog } from 'vant'
import { getUrlKey, MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import wxShare from '@/components/wxShare'
import { GetServiceUrl, GetSelfUrl } from '@/utils/request'
import wx from 'weixin-js-sdk'

export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Dialog.name]: Dialog,
    wxShare
  },
  data() {
    return {
      titleTop: '来吧！珊瑚卫士！',
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          bulletClass: 'my-bullet',
          bulletActiveClass: 'my-bullet-active'
        }
      },
      picList: [
        { id: -1, src: 'https://res.diveboss.net/activity/ilab202205/picnull.png' },
        { id: 0, src: 'https://res.diveboss.net/activity/ilab202205/pic0.jpg' },
        { id: 1, src: 'https://res.diveboss.net/activity/ilab202205/pic1.jpg' },
        { id: 2, src: 'https://res.diveboss.net/activity/ilab202205/pic2.jpg' },
        { id: 3, src: 'https://res.diveboss.net/activity/ilab202205/pic3.jpg' },
        { id: 4, src: 'https://res.diveboss.net/activity/ilab202205/pic4.jpg' },
        { id: 5, src: 'https://res.diveboss.net/activity/ilab202205/pic5.jpg' },
        { id: 6, src: 'https://res.diveboss.net/activity/ilab202205/pic6.jpg' },
        { id: 7, src: 'https://res.diveboss.net/activity/ilab202205/pic7.jpg' },
        { id: -2, src: 'https://res.diveboss.net/activity/ilab202205/picnull.png' }],
      nickName: '',
      selectImage: '0',
      buttonLoading: false,
      papaerImgSrc: '',
      state: 'welcome',
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: undefined,
      shareIcon: ''
    }
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.backChange, false) // false阻止默认事件
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.backChange, false) // false阻止默认事件
  },
  created() {
    setTimeout(() => {
      this.titleTop = ''
      this.titleTop = '来吧！珊瑚卫士！'
    }, 1)
    this.titleTop = GetSysTitle()
    this.init()
    document.addEventListener('DOMContentLoaded', function() {
      function audioAutoPlay() {
        var audio = document.getElementById('audioBgm')
        audio.play()
        document.addEventListener('WeixinJSBridgeReady', function() {
          audio.play()
        }, false)
      }
      audioAutoPlay()
    })
    // --创建触摸监听，当浏览器打开页面时，触摸屏幕触发事件，进行音频播放
    document.addEventListener('touchstart', function() {
      function audioAutoPlay() {
        var audio = document.getElementById('audioBgm')
        audio.play()
      }
      audioAutoPlay()
    })
    document.addEventListener('WeixinJSBridgeReady', function() {
      function audioAutoPlay() {
        var audio = document.getElementById('audioBgm')
        audio.play()
      }
      audioAutoPlay()
    })
  },
  methods: {
    getUrlKey,
    MyNotify,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onImgChange(index) {
      this.selectImage = this.$refs.imgSwiper.$swiper.activeIndex
    },
    backChange() {
      console.log('监听到了')
      if (this.state === 'paper') {
        this.state = 'welcome'
        this.papaerImgSrc = ''
      } else {
        Dialog.confirm({
          title: '退出活动',
          message: '您是否要退出"' + this.titleTop + '"活动',
          confirmButtonText: '退出',
          cancelButtonText: '返回'
        }).then(() => {
          window.location.href = 'about:blank'
          // eslint-disable-next-line no-undef
          wx.closeWindow()
        }).catch(() => {
        })
      }
    },
    onShareFinish() {
      this.shareUrl = undefined
    },
    onBuild() {
      this.buttonLoading = true
      setTimeout(() => {
        this.buttonLoading = false
      }, 300)
      if (!this.nickName) {
        MyNotify('error', '请输入姓名或者昵称')
        return
      }
      this.state = 'paper'
      this.papaerImgSrc = GetServiceUrl() + 'ThirdActivitie/GetiLab202205Image?nickName=' + this.nickName +
        '&imgId=' + this.selectImage +
        '&thirdUserId=' + this.userInfo.thirdUserId
      console.log('imgUrl', this.papaerImgSrc)
    },
    initShare(url) {
      this.shareTitle = '来吧！珊瑚卫士！'
      this.shareAbout = '生成你的专属环保海报，有机会到海南岛种珊瑚！'
      this.shareTimeline = '来吧！珊瑚卫士！'
      this.shareIcon = GetSelfUrl() + 'img/third/ilab202205/shareIcon.jpg'
      this.shareUrl = undefined
      this.shareUrl = 'https://m.diveboss.net/ilab/202205'
    },
    init() {
      var thirdUserId = getUrlKey('thirdUserId')
      var code = getUrlKey('code')
      if (!thirdUserId && !code) {
        // 登录
        this.getWxLoginUrl((url) => {
          console.log('跳转页面去登录', url)
          window.location.href = url
        })
        return
      }
      var my = this
      this.$router.push('/ilab/202205')
      if (thirdUserId) {
        this.loginAndRegThirdUserInfo(null, thirdUserId, () => {
          this.loginThirdFinish(my)
          this.initShare()
        })
      } else {
        // 读取注册用户信息
        this.loginAndRegThirdUserInfo(code, null, () => {
          this.loginThirdFinish(my)
          this.initShare()
        })
      }
    },
    getWxLoginUrl(callback) {
      request({
        url: '/ThirdActivitie/wechatLogin',
        method: 'post',
        data: {
          url: 'https://m.diveboss.net/ilab/202205',
          type: 'iLab'
        }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        var url = Response.data
        if (callback) {
          callback(url)
        }
      })
    },
    loginAndRegThirdUserInfo(code, thirdUserId, callback) {
      request({
        url: '/ThirdActivitie/GetAndRegThirdActiviteUser',
        method: 'post',
        data: {
          code: code,
          thirdUserId: thirdUserId,
          type: 'iLab',
          keyCode: 'iLab202205'
        }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.userInfo = Response.data
        if (callback) {
          callback()
        }
      })
    },
    loginThirdFinish(my) {
      if (my.userInfo.isFollow) {
        my.$router.push('/ilab/202205?thirdUserId=' + my.userInfo.thirdUserId)
      }
      if (my.userInfo.nickName) {
        my.nickName = my.userInfo.nickName
      }
    }
  }
}
</script>
<style>
  .my-bullet{
    width: 0.5rem;
    height: 0.5rem;
    display: inline-block;
    border-radius: 50%;
    background: #F0F3F2;
  }
  .swiper-pagination :nth-child(n){
      margin: 0 0.25rem;
    }
  .my-bullet-active{
    background: #02E5F6;
  }
  input.van-field__control::-webkit-input-placeholder {
    color: #fff;
    text-align: center;
  }
    input.van-field__control {
    color: #fff;
    text-align: center;
  }
</style>
<style scoped>
.AllBack{
  background-image: url('https://res.diveboss.net/activity/ilab202205/back.jpg');
  background-size:cover;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.topSwipe{
  margin-top: 2em;
  margin-left: -40vw;
  width: 180vw;
}
.topSwipe .topImg{
  text-align: center;
  width: 50vw;
  height: 112vw;
}
.topSwipe .topImg img{
  width: 100%;
  border-radius: 1em;
  overflow: hidden;
  display: block;
}
.aboutStr{
  text-align: center;
  color: #fff;
  font-weight: 700;
  font-size: 0.9em;
}
.inputRect{
  width: 40vw;
  margin-left: 30vw;
  margin-top: 2em;
}
.inputRect .inputLine{
  background-color: #86A6CF;
  border:0px;
  text-align: center;
  font-weight: 700;
  border-radius: 0.5em;
  overflow: hidden;
}
.buttonRect{
  border:1px solid #fff;
  border-radius: 5em;
  height: 3em;
  line-height: 3em;
  width:60vw;
  margin-left: 20vw;
  text-align: center;
  margin-top: 2.5em;
}
.buttonRect span{
  font-size: 1em;
  font-weight: 700;
  color: #fff;
}
.buttonRectSelect{
  border-color: #02E5F6 !important;
}
.papaerRect{
  background-image: url('https://res.diveboss.net/activity/ilab202205/back.jpg');
  background-size:cover;
  width: 100vw;
  height: 100vh;
  overflow-y:auto;
  overflow-x: hidden;
  display: block;
}
.papaerRect .papaer{
  position: relative;
}

.papaerRect img{
  width: 100vw;
}
.papaerRect .shareAbout{
  margin-left: 6vw;
  margin-top: 38vw;
  font-size: 0.7em;
  padding: 0 1em;
  color: #000;
  background-color: #F1F0F4;
  border-radius: 2em;
  line-height: 2em;
  position: absolute;
}
</style>
